import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewPrecioSugerido = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'precio_sugerido',
        name: 'Precio Sugerido',
        component: ViewPrecioSugerido,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
